import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HomeHeroShowcaseBlockConfig } from '@front-platform/content-builder';
import { homeHeroShowcaseBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
export interface HomeHeroShowcaseBlockRuntimeConfig {
  '"button-size-y"'?: 'S' | 'M' | 'L';
}

export type HomeHeroShowcaseBlockConfigInput = Partial<
  Omit<HomeHeroShowcaseBlockConfig, keyof HomeHeroShowcaseBlockRuntimeConfig> &
    HomeHeroShowcaseBlockRuntimeConfig
>;
export type HomeHeroShowcaseBlockResolvedConfig = Omit<
  HomeHeroShowcaseBlockConfig,
  keyof HomeHeroShowcaseBlockRuntimeConfig
> &
  Partial<HomeHeroShowcaseBlockRuntimeConfig>;
export interface HomeHeroShowcaseBlockContract extends ConfigComponentContract<
  HomeHeroShowcaseBlockConfigInput,
  HomeHeroShowcaseBlockResolvedConfig
> {}

@Component({
  selector: 'app-home-hero-showcase-block',
  templateUrl: './home-hero-showcase-block.component.html',
  standalone: false,
})
export class HomeHeroShowcaseBlockComponent implements HomeHeroShowcaseBlockContract {
  readonly config = input<HomeHeroShowcaseBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HomeHeroShowcaseBlockConfig,
    HomeHeroShowcaseBlockRuntimeConfig
  >(homeHeroShowcaseBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string | undefined {
    return this.resolvedConfig()['title'] as unknown as string | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
  get linkLabel(): string | undefined {
    return this.resolvedConfig()['link_label'] as unknown as string | undefined;
  }
  get buttonSizeY(): 'S' | 'M' | 'L' {
    return this.resolvedConfig()['"button-size-y"'] as unknown as 'S' | 'M' | 'L';
  }
  get backgroundImage(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['background_image'] as unknown as
      IContentBuilderFieldImage | undefined;
  }

  scrollTo(): void {
    const pageHeight = window.innerHeight;
    window.scrollBy(0, pageHeight);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HomeHeroShowcaseBlockComponent, {
  'keyAliases': { 'button_size_y': '"button-size-y"' },
});
